<div *ngIf="list && (((isProjectsLoading$ | async) === false) && ((isUsersLoading$ | async) === false))">
  <!-- header toolbar -->
  <div class="app-toolbar" *ngIf="list.length > 0">
    <div class="app-toolbar-row">
      <h3 class="mat-body subtitle">
        <span *ngIf="status">Active</span>
        <span *ngIf="!status">Suspended</span>
      </h3>
      <span class="fill-remaining-space"></span>
      <span class="app-toolbar-action"> </span>
    </div>
    <div class="app-toolbar-row">
      <span class="app-toolbar-action button left">
        <!-- sort button if more than one item in the list -->
        <app-sort-button
          *ngIf="list.length > 1"
          [icon]="'sort_by_alpha'"
          [sortProps]="sortProps"
          [activeKey]="sortBy"
          (sortKeyChange)="sortList($event)">
        </app-sort-button>
      </span>
      <h2 class="mat-headline-6">
        <span *ngIf="projectUuid">{{ list.length | i18nPlural : itemPluralMapping['member'] }}</span>
        <span *ngIf="!projectUuid">{{ list.length | i18nPlural : itemPluralMapping['user'] }}</span>
      </h2>
      <span class="fill-remaining-space"></span>
      <span class="app-toolbar-action button right" *ngIf="status && createNew && (isSysAdmin$ | async)">
        <button mat-flat-button [color]="'primary'" (click)="openDialog('createUser')">Create new</button>
      </span>
    </div>
  </div>

  <!-- content: list -->
  <table class="table more-space-bottom" [class.deactivated]="!status">
    <tr class="table-entry" *ngFor="let user of list; trackBy:trackByFn; let last = last" [class.no-border]="last">
      <!-- avatar -->
      <td class="avatar-cell">
        <img appAdminImage [image]="user.email" [type]="'user'" alt="avatar" class="avatar-image" />
      </td>

      <!-- name and e-mail address -->
      <td class="table-info">
        <h5 class="mat-subtitle-1 info-names">
          <!-- Names hidden on phone devices -->
          {{ user.givenName }} {{ user.familyName }}
        </h5>
        <p class="mat-subtitle-2">
          <span class="info-username">{{ user.username }} </span>
          <!-- Email hidden on phone devices -->
          <span class="info-email">| {{ user.email }}</span>
          <!-- TODO: question: how public should the email address be? -->
        </p>
      </td>

      <!-- admin: only in project view -->
      <td class="table-admin-chip">
        <mat-chip-listbox *ngIf="projectUuid">
          <mat-chip class="admin-chip" *ngIf="userIsProjectAdmin(user.permissions)">Admin</mat-chip>
        </mat-chip-listbox>
        <mat-chip-listbox *ngIf="!projectUuid && userIsSystemAdmin(user.permissions)">
          <mat-chip class="sys-admin-chip">System Admin</mat-chip>
        </mat-chip-listbox>
      </td>

      <!-- group: only in project view -->
      <td class="table-select-group">
        <app-select-group
          *ngIf="(isCurrentProjectAdminOrSysAdmin$ | async) === true && projectUuid"
          [projectCode]="(project$ | async)?.shortcode"
          [projectid]="(project$ | async)?.id"
          [permissions]="
                        user.permissions.groupsPerProject[(project$ | async)?.id]
                    "
          [disabled]="!status"
          (groupChange)="updateGroupsMembership(user.id, $event)">
        </app-select-group>
      </td>

      <!-- action: menu with edit, remove, etc. -->
      <td class="table-action">
        <button mat-icon-button [matMenuTriggerFor]="projectUserMenu" [disabled]="disableMenu$ | async">
          <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu #projectUserMenu="matMenu" xPosition="before" class="menu">
          <!-- update user's admin group membership; only in project view -->
          <button
            mat-menu-item
            *ngIf="projectUuid && user.status"
            (click)="
                            updateProjectAdminMembership(
                                user.id,
                                user.permissions
                            )
                        ">
            <span *ngIf="!userIsProjectAdmin(user.permissions)">Add</span>
            <span *ngIf="userIsProjectAdmin(user.permissions)">Remove</span>
            <span>as project admin</span>
          </button>
          <!-- update user's system admin group membership; only in system admin view -->
          <button
            mat-menu-item
            *ngIf="
                            !projectUuid &&
                            (user$ | async)?.status &&
                            (isSysAdmin$ | async) &&
                            user.username !== (username$ | async)
                        "
            (click)="
                            updateSystemAdminMembership(
                                user,
                                !userIsSystemAdmin(user.permissions)
                            )
                        ">
            <span *ngIf="!userIsSystemAdmin(user.permissions)">Add</span>
            <span *ngIf="userIsSystemAdmin(user.permissions)">Remove</span>
            <span>as system admin</span>
          </button>
          <!-- update user's profile data; only for system admin -->
          <button mat-menu-item *ngIf="(isSysAdmin$ | async) && user.status" (click)="openDialog('editUser', user)">
            {{ projectUuid ? 'Edit member' : 'Edit user' }}
          </button>
          <button mat-menu-item *ngIf="(isSysAdmin$ | async) && user.status" (click)="openDialog('editPassword', user)">
            {{ projectUuid ? "Change member's password" : "Change user's password" }}
          </button>
          <!-- remove user from project; only in project view -->
          <button
            mat-menu-item
            *ngIf="projectUuid"
            (click)="
                            askToRemoveFromProject(user)
                        ">
            Remove member from project
          </button>
          <!-- manage project membership; only in system view -->
          <button
            mat-menu-item
            *ngIf="user.status && (isSysAdmin$ | async) && !projectUuid"
            (click)="
                            openDialog('manageProjectMembership', user)
                        ">
            Manage project membership
          </button>
          <!-- delete / reactivate user -->
          <button
            mat-menu-item
            *ngIf="user.status && (isSysAdmin$ | async) && !projectUuid"
            (click)="askToDeleteUser(user.username, user.id)">
            Suspend user
          </button>
          <button
            mat-menu-item
            *ngIf="!user.status && (isSysAdmin$ | async) && !projectUuid"
            (click)="askToActivateUser(user.username, user.id)">
            Reactivate user
          </button>
        </mat-menu>
      </td>
    </tr>
  </table>
</div>
